module.exports = __webpack_public_path__ + "media/images/default/homepage/about/driving-8faeb814396175498c9b487777820bf7.svg";